import SettingsTabPage from "../../components/feature/settings/settings-tab-page";
import VoiceSettings from "../../components/feature/settings/voice/voice-settings";

export default function VoiceTab() {
  return (
    <SettingsTabPage>
      <VoiceSettings />
    </SettingsTabPage>
  );
}
